import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { getLinkToDisclaimersPage } from '../../../../services/mlsComplianceDataService'
import { ListingDetailsListing } from '../../../../types/listings'
import { DataProvidedByMlsAbbrevAndNumber } from '../DataProvidedByMlsAbbrevAndNumber'
import { MlsLogo } from '../MlsLogo'
import styles from './DataProvidedByMlsAbbrevAndNumberWithLogo.module.scss'

export type ListingWithMlsNumber = Pick<
  ListingDetailsListing,
  'source' | 'originatingSystemName' | 'disclaimer' | 'mlsNumber'
>

interface DataProvidedByMlsAbbrevAndNumberWithLogoProps {
  listing: ListingWithMlsNumber
  className?: string
}

export const DataProvidedByMlsAbbrevAndNumberWithLogo = ({
  listing,
  className,
}: DataProvidedByMlsAbbrevAndNumberWithLogoProps) => {
  return (
    <div className={classnames(styles.container, className)}>
      <DataProvidedByMlsAbbrevAndNumber listing={listing} />
      <Link
        to={getLinkToDisclaimersPage(listing.originatingSystemName)}
        target='_blank'
      >
        <MlsLogo listing={listing} />
      </Link>
    </div>
  )
}
